import { IPagination } from 'app/types/common';

export interface IClubsState {
  readonly clubsById?: any;
  readonly clubIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationClubIds?: string[];
  readonly currentClubId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IClubsSelector extends IClubsState {
  readonly currentClub?: any;
  readonly currentFormClub?: any;
  readonly getClubsFilteredByTagInSelectFormat?: any;
  readonly clubsByIdInSelectFormat?: any;
}

export enum ClubsActionTypes {
  GET_ALL_CLUBS_REQUESTED = 'redux-app/clubs/GET_ALL_CLUBS_REQUESTED',
  GET_ALL_CLUBS_PENDING = 'redux-app/clubs/GET_ALL_CLUBS_PENDING',
  GET_ALL_CLUBS_SUCCESS = 'redux-app/clubs/GET_ALL_CLUBS_SUCCESS',
  GET_ALL_CLUBS_FAIL = 'redux-app/clubs/GET_ALL_CLUBS_FAIL',
  GET_CLUB_REQUESTED = 'redux-app/clubs/GET_CLUB_REQUESTED',
  GET_CLUB_PENDING = 'redux-app/clubs/GET_CLUB_PENDING',
  GET_CLUB_SUCCESS = 'redux-app/clubs/GET_CLUB_SUCCESS',
  GET_CLUB_FAIL = 'redux-app/clubs/GET_CLUB_FAIL',
  UPDATE_CLUB_REQUESTED = 'redux-app/clubs/UPDATE_CLUB_REQUESTED',
  UPDATE_CLUB_PENDING = 'redux-app/clubs/UPDATE_CLUB_PENDING',
  UPDATE_CLUB_SUCCESS = 'redux-app/clubs/UPDATE_CLUB_SUCCESS',
  UPDATE_CLUB_FAIL = 'redux-app/clubs/UPDATE_CLUB_FAIL',
  CREATE_CLUB_REQUESTED = 'redux-app/clubs/CREATE_CLUB_REQUESTED',
  CREATE_CLUB_PENDING = 'redux-app/clubs/CREATE_CLUB_PENDING',
  CREATE_CLUB_SUCCESS = 'redux-app/clubs/CREATE_CLUB_SUCCESS',
  CREATE_CLUB_FAIL = 'redux-app/clubs/CREATE_CLUB_FAIL',
  DELETE_CLUB_REQUESTED = 'redux-app/clubs/DELETE_CLUB_REQUESTED',
  DELETE_CLUB_PENDING = 'redux-app/clubs/DELETE_CLUB_PENDING',
  DELETE_CLUB_SUCCESS = 'redux-app/clubs/DELETE_CLUB_SUCCESS',
  DELETE_CLUB_FAIL = 'redux-app/clubs/DELETE_CLUB_FAIL',
  SELECT_CLUB_REQUESTED = 'redux-app/clubs/SELECT_CLUB_REQUESTED',
  SELECT_LAST_CLUB_REQUESTED = 'redux-app/clubs/SELECT_LAST_CLUB_REQUESTED',
  SELECT_LAST_CLUB_PENDING = 'redux-app/clubs/SELECT_LAST_CLUB_PENDING',
  SELECT_LAST_CLUB_FINISHED = 'redux-app/clubs/SELECT_LAST_CLUB_FINISHED'
}

export default null;
